/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const api = $root.api = (() => {

    /**
     * Namespace api.
     * @exports api
     * @namespace
     */
    const api = {};

    api.trades = (function() {

        /**
         * Namespace trades.
         * @memberof api
         * @namespace
         */
        const trades = {};

        trades.OrderUpdate = (function() {

            /**
             * Properties of an OrderUpdate.
             * @memberof api.trades
             * @interface IOrderUpdate
             * @property {string|null} [orderId] OrderUpdate orderId
             * @property {string|null} [entityName] OrderUpdate entityName
             * @property {number|Long|null} [lot] OrderUpdate lot
             * @property {number|Long|null} [quantity] OrderUpdate quantity
             * @property {string|null} [orderType] OrderUpdate orderType
             * @property {string|null} [orderStatus] OrderUpdate orderStatus
             * @property {number|null} [executedPrice] OrderUpdate executedPrice
             * @property {number|Long|null} [elapsedTime] OrderUpdate elapsedTime
             * @property {string|null} [errorMessage] OrderUpdate errorMessage
             * @property {number|null} [errorCode] OrderUpdate errorCode
             * @property {number|Long|null} [timestamp] OrderUpdate timestamp
             * @property {number|Long|null} [reqQuantity] OrderUpdate reqQuantity
             * @property {string|null} [requestId] OrderUpdate requestId
             * @property {number|Long|null} [requestedLot] OrderUpdate requestedLot
             * @property {number|null} [realisedGainLoss] OrderUpdate realisedGainLoss
             */

            /**
             * Constructs a new OrderUpdate.
             * @memberof api.trades
             * @classdesc Represents an OrderUpdate.
             * @implements IOrderUpdate
             * @constructor
             * @param {api.trades.IOrderUpdate=} [properties] Properties to set
             */
            function OrderUpdate(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OrderUpdate orderId.
             * @member {string} orderId
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.orderId = "";

            /**
             * OrderUpdate entityName.
             * @member {string} entityName
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.entityName = "";

            /**
             * OrderUpdate lot.
             * @member {number|Long} lot
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.lot = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OrderUpdate quantity.
             * @member {number|Long} quantity
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.quantity = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OrderUpdate orderType.
             * @member {string} orderType
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.orderType = "";

            /**
             * OrderUpdate orderStatus.
             * @member {string} orderStatus
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.orderStatus = "";

            /**
             * OrderUpdate executedPrice.
             * @member {number} executedPrice
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.executedPrice = 0;

            /**
             * OrderUpdate elapsedTime.
             * @member {number|Long} elapsedTime
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.elapsedTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OrderUpdate errorMessage.
             * @member {string} errorMessage
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.errorMessage = "";

            /**
             * OrderUpdate errorCode.
             * @member {number} errorCode
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.errorCode = 0;

            /**
             * OrderUpdate timestamp.
             * @member {number|Long} timestamp
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OrderUpdate reqQuantity.
             * @member {number|Long} reqQuantity
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.reqQuantity = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OrderUpdate requestId.
             * @member {string} requestId
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.requestId = "";

            /**
             * OrderUpdate requestedLot.
             * @member {number|Long} requestedLot
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.requestedLot = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * OrderUpdate realisedGainLoss.
             * @member {number|null|undefined} realisedGainLoss
             * @memberof api.trades.OrderUpdate
             * @instance
             */
            OrderUpdate.prototype.realisedGainLoss = null;

            // OneOf field names bound to virtual getters and setters
            let $oneOfFields;

            // Virtual OneOf for proto3 optional field
            Object.defineProperty(OrderUpdate.prototype, "_realisedGainLoss", {
                get: $util.oneOfGetter($oneOfFields = ["realisedGainLoss"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new OrderUpdate instance using the specified properties.
             * @function create
             * @memberof api.trades.OrderUpdate
             * @static
             * @param {api.trades.IOrderUpdate=} [properties] Properties to set
             * @returns {api.trades.OrderUpdate} OrderUpdate instance
             */
            OrderUpdate.create = function create(properties) {
                return new OrderUpdate(properties);
            };

            /**
             * Encodes the specified OrderUpdate message. Does not implicitly {@link api.trades.OrderUpdate.verify|verify} messages.
             * @function encode
             * @memberof api.trades.OrderUpdate
             * @static
             * @param {api.trades.IOrderUpdate} message OrderUpdate message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrderUpdate.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderId);
                if (message.entityName != null && Object.hasOwnProperty.call(message, "entityName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.entityName);
                if (message.lot != null && Object.hasOwnProperty.call(message, "lot"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.lot);
                if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.quantity);
                if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.orderType);
                if (message.orderStatus != null && Object.hasOwnProperty.call(message, "orderStatus"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.orderStatus);
                if (message.executedPrice != null && Object.hasOwnProperty.call(message, "executedPrice"))
                    writer.uint32(/* id 7, wireType 1 =*/57).double(message.executedPrice);
                if (message.elapsedTime != null && Object.hasOwnProperty.call(message, "elapsedTime"))
                    writer.uint32(/* id 8, wireType 0 =*/64).int64(message.elapsedTime);
                if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.errorMessage);
                if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                    writer.uint32(/* id 11, wireType 0 =*/88).int32(message.errorCode);
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    writer.uint32(/* id 12, wireType 0 =*/96).int64(message.timestamp);
                if (message.reqQuantity != null && Object.hasOwnProperty.call(message, "reqQuantity"))
                    writer.uint32(/* id 13, wireType 0 =*/104).int64(message.reqQuantity);
                if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.requestId);
                if (message.requestedLot != null && Object.hasOwnProperty.call(message, "requestedLot"))
                    writer.uint32(/* id 15, wireType 0 =*/120).int64(message.requestedLot);
                if (message.realisedGainLoss != null && Object.hasOwnProperty.call(message, "realisedGainLoss"))
                    writer.uint32(/* id 16, wireType 1 =*/129).double(message.realisedGainLoss);
                return writer;
            };

            /**
             * Encodes the specified OrderUpdate message, length delimited. Does not implicitly {@link api.trades.OrderUpdate.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.trades.OrderUpdate
             * @static
             * @param {api.trades.IOrderUpdate} message OrderUpdate message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OrderUpdate.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OrderUpdate message from the specified reader or buffer.
             * @function decode
             * @memberof api.trades.OrderUpdate
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.trades.OrderUpdate} OrderUpdate
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrderUpdate.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.trades.OrderUpdate();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.orderId = reader.string();
                            break;
                        }
                    case 2: {
                            message.entityName = reader.string();
                            break;
                        }
                    case 3: {
                            message.lot = reader.int64();
                            break;
                        }
                    case 4: {
                            message.quantity = reader.int64();
                            break;
                        }
                    case 5: {
                            message.orderType = reader.string();
                            break;
                        }
                    case 6: {
                            message.orderStatus = reader.string();
                            break;
                        }
                    case 7: {
                            message.executedPrice = reader.double();
                            break;
                        }
                    case 8: {
                            message.elapsedTime = reader.int64();
                            break;
                        }
                    case 9: {
                            message.errorMessage = reader.string();
                            break;
                        }
                    case 11: {
                            message.errorCode = reader.int32();
                            break;
                        }
                    case 12: {
                            message.timestamp = reader.int64();
                            break;
                        }
                    case 13: {
                            message.reqQuantity = reader.int64();
                            break;
                        }
                    case 14: {
                            message.requestId = reader.string();
                            break;
                        }
                    case 15: {
                            message.requestedLot = reader.int64();
                            break;
                        }
                    case 16: {
                            message.realisedGainLoss = reader.double();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OrderUpdate message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.trades.OrderUpdate
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.trades.OrderUpdate} OrderUpdate
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OrderUpdate.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OrderUpdate message.
             * @function verify
             * @memberof api.trades.OrderUpdate
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OrderUpdate.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                let properties = {};
                if (message.orderId != null && message.hasOwnProperty("orderId"))
                    if (!$util.isString(message.orderId))
                        return "orderId: string expected";
                if (message.entityName != null && message.hasOwnProperty("entityName"))
                    if (!$util.isString(message.entityName))
                        return "entityName: string expected";
                if (message.lot != null && message.hasOwnProperty("lot"))
                    if (!$util.isInteger(message.lot) && !(message.lot && $util.isInteger(message.lot.low) && $util.isInteger(message.lot.high)))
                        return "lot: integer|Long expected";
                if (message.quantity != null && message.hasOwnProperty("quantity"))
                    if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
                        return "quantity: integer|Long expected";
                if (message.orderType != null && message.hasOwnProperty("orderType"))
                    if (!$util.isString(message.orderType))
                        return "orderType: string expected";
                if (message.orderStatus != null && message.hasOwnProperty("orderStatus"))
                    if (!$util.isString(message.orderStatus))
                        return "orderStatus: string expected";
                if (message.executedPrice != null && message.hasOwnProperty("executedPrice"))
                    if (typeof message.executedPrice !== "number")
                        return "executedPrice: number expected";
                if (message.elapsedTime != null && message.hasOwnProperty("elapsedTime"))
                    if (!$util.isInteger(message.elapsedTime) && !(message.elapsedTime && $util.isInteger(message.elapsedTime.low) && $util.isInteger(message.elapsedTime.high)))
                        return "elapsedTime: integer|Long expected";
                if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                    if (!$util.isString(message.errorMessage))
                        return "errorMessage: string expected";
                if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                    if (!$util.isInteger(message.errorCode))
                        return "errorCode: integer expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                        return "timestamp: integer|Long expected";
                if (message.reqQuantity != null && message.hasOwnProperty("reqQuantity"))
                    if (!$util.isInteger(message.reqQuantity) && !(message.reqQuantity && $util.isInteger(message.reqQuantity.low) && $util.isInteger(message.reqQuantity.high)))
                        return "reqQuantity: integer|Long expected";
                if (message.requestId != null && message.hasOwnProperty("requestId"))
                    if (!$util.isString(message.requestId))
                        return "requestId: string expected";
                if (message.requestedLot != null && message.hasOwnProperty("requestedLot"))
                    if (!$util.isInteger(message.requestedLot) && !(message.requestedLot && $util.isInteger(message.requestedLot.low) && $util.isInteger(message.requestedLot.high)))
                        return "requestedLot: integer|Long expected";
                if (message.realisedGainLoss != null && message.hasOwnProperty("realisedGainLoss")) {
                    properties._realisedGainLoss = 1;
                    if (typeof message.realisedGainLoss !== "number")
                        return "realisedGainLoss: number expected";
                }
                return null;
            };

            /**
             * Creates an OrderUpdate message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.trades.OrderUpdate
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.trades.OrderUpdate} OrderUpdate
             */
            OrderUpdate.fromObject = function fromObject(object) {
                if (object instanceof $root.api.trades.OrderUpdate)
                    return object;
                let message = new $root.api.trades.OrderUpdate();
                if (object.orderId != null)
                    message.orderId = String(object.orderId);
                if (object.entityName != null)
                    message.entityName = String(object.entityName);
                if (object.lot != null)
                    if ($util.Long)
                        (message.lot = $util.Long.fromValue(object.lot)).unsigned = false;
                    else if (typeof object.lot === "string")
                        message.lot = parseInt(object.lot, 10);
                    else if (typeof object.lot === "number")
                        message.lot = object.lot;
                    else if (typeof object.lot === "object")
                        message.lot = new $util.LongBits(object.lot.low >>> 0, object.lot.high >>> 0).toNumber();
                if (object.quantity != null)
                    if ($util.Long)
                        (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
                    else if (typeof object.quantity === "string")
                        message.quantity = parseInt(object.quantity, 10);
                    else if (typeof object.quantity === "number")
                        message.quantity = object.quantity;
                    else if (typeof object.quantity === "object")
                        message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
                if (object.orderType != null)
                    message.orderType = String(object.orderType);
                if (object.orderStatus != null)
                    message.orderStatus = String(object.orderStatus);
                if (object.executedPrice != null)
                    message.executedPrice = Number(object.executedPrice);
                if (object.elapsedTime != null)
                    if ($util.Long)
                        (message.elapsedTime = $util.Long.fromValue(object.elapsedTime)).unsigned = false;
                    else if (typeof object.elapsedTime === "string")
                        message.elapsedTime = parseInt(object.elapsedTime, 10);
                    else if (typeof object.elapsedTime === "number")
                        message.elapsedTime = object.elapsedTime;
                    else if (typeof object.elapsedTime === "object")
                        message.elapsedTime = new $util.LongBits(object.elapsedTime.low >>> 0, object.elapsedTime.high >>> 0).toNumber();
                if (object.errorMessage != null)
                    message.errorMessage = String(object.errorMessage);
                if (object.errorCode != null)
                    message.errorCode = object.errorCode | 0;
                if (object.timestamp != null)
                    if ($util.Long)
                        (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
                    else if (typeof object.timestamp === "string")
                        message.timestamp = parseInt(object.timestamp, 10);
                    else if (typeof object.timestamp === "number")
                        message.timestamp = object.timestamp;
                    else if (typeof object.timestamp === "object")
                        message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
                if (object.reqQuantity != null)
                    if ($util.Long)
                        (message.reqQuantity = $util.Long.fromValue(object.reqQuantity)).unsigned = false;
                    else if (typeof object.reqQuantity === "string")
                        message.reqQuantity = parseInt(object.reqQuantity, 10);
                    else if (typeof object.reqQuantity === "number")
                        message.reqQuantity = object.reqQuantity;
                    else if (typeof object.reqQuantity === "object")
                        message.reqQuantity = new $util.LongBits(object.reqQuantity.low >>> 0, object.reqQuantity.high >>> 0).toNumber();
                if (object.requestId != null)
                    message.requestId = String(object.requestId);
                if (object.requestedLot != null)
                    if ($util.Long)
                        (message.requestedLot = $util.Long.fromValue(object.requestedLot)).unsigned = false;
                    else if (typeof object.requestedLot === "string")
                        message.requestedLot = parseInt(object.requestedLot, 10);
                    else if (typeof object.requestedLot === "number")
                        message.requestedLot = object.requestedLot;
                    else if (typeof object.requestedLot === "object")
                        message.requestedLot = new $util.LongBits(object.requestedLot.low >>> 0, object.requestedLot.high >>> 0).toNumber();
                if (object.realisedGainLoss != null)
                    message.realisedGainLoss = Number(object.realisedGainLoss);
                return message;
            };

            /**
             * Creates a plain object from an OrderUpdate message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.trades.OrderUpdate
             * @static
             * @param {api.trades.OrderUpdate} message OrderUpdate
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OrderUpdate.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.orderId = "";
                    object.entityName = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.lot = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.lot = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.quantity = options.longs === String ? "0" : 0;
                    object.orderType = "";
                    object.orderStatus = "";
                    object.executedPrice = 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.elapsedTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.elapsedTime = options.longs === String ? "0" : 0;
                    object.errorMessage = "";
                    object.errorCode = 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.timestamp = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.reqQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.reqQuantity = options.longs === String ? "0" : 0;
                    object.requestId = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.requestedLot = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.requestedLot = options.longs === String ? "0" : 0;
                }
                if (message.orderId != null && message.hasOwnProperty("orderId"))
                    object.orderId = message.orderId;
                if (message.entityName != null && message.hasOwnProperty("entityName"))
                    object.entityName = message.entityName;
                if (message.lot != null && message.hasOwnProperty("lot"))
                    if (typeof message.lot === "number")
                        object.lot = options.longs === String ? String(message.lot) : message.lot;
                    else
                        object.lot = options.longs === String ? $util.Long.prototype.toString.call(message.lot) : options.longs === Number ? new $util.LongBits(message.lot.low >>> 0, message.lot.high >>> 0).toNumber() : message.lot;
                if (message.quantity != null && message.hasOwnProperty("quantity"))
                    if (typeof message.quantity === "number")
                        object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
                    else
                        object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
                if (message.orderType != null && message.hasOwnProperty("orderType"))
                    object.orderType = message.orderType;
                if (message.orderStatus != null && message.hasOwnProperty("orderStatus"))
                    object.orderStatus = message.orderStatus;
                if (message.executedPrice != null && message.hasOwnProperty("executedPrice"))
                    object.executedPrice = options.json && !isFinite(message.executedPrice) ? String(message.executedPrice) : message.executedPrice;
                if (message.elapsedTime != null && message.hasOwnProperty("elapsedTime"))
                    if (typeof message.elapsedTime === "number")
                        object.elapsedTime = options.longs === String ? String(message.elapsedTime) : message.elapsedTime;
                    else
                        object.elapsedTime = options.longs === String ? $util.Long.prototype.toString.call(message.elapsedTime) : options.longs === Number ? new $util.LongBits(message.elapsedTime.low >>> 0, message.elapsedTime.high >>> 0).toNumber() : message.elapsedTime;
                if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                    object.errorMessage = message.errorMessage;
                if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                    object.errorCode = message.errorCode;
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (typeof message.timestamp === "number")
                        object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                    else
                        object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
                if (message.reqQuantity != null && message.hasOwnProperty("reqQuantity"))
                    if (typeof message.reqQuantity === "number")
                        object.reqQuantity = options.longs === String ? String(message.reqQuantity) : message.reqQuantity;
                    else
                        object.reqQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.reqQuantity) : options.longs === Number ? new $util.LongBits(message.reqQuantity.low >>> 0, message.reqQuantity.high >>> 0).toNumber() : message.reqQuantity;
                if (message.requestId != null && message.hasOwnProperty("requestId"))
                    object.requestId = message.requestId;
                if (message.requestedLot != null && message.hasOwnProperty("requestedLot"))
                    if (typeof message.requestedLot === "number")
                        object.requestedLot = options.longs === String ? String(message.requestedLot) : message.requestedLot;
                    else
                        object.requestedLot = options.longs === String ? $util.Long.prototype.toString.call(message.requestedLot) : options.longs === Number ? new $util.LongBits(message.requestedLot.low >>> 0, message.requestedLot.high >>> 0).toNumber() : message.requestedLot;
                if (message.realisedGainLoss != null && message.hasOwnProperty("realisedGainLoss")) {
                    object.realisedGainLoss = options.json && !isFinite(message.realisedGainLoss) ? String(message.realisedGainLoss) : message.realisedGainLoss;
                    if (options.oneofs)
                        object._realisedGainLoss = "realisedGainLoss";
                }
                return object;
            };

            /**
             * Converts this OrderUpdate to JSON.
             * @function toJSON
             * @memberof api.trades.OrderUpdate
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OrderUpdate.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for OrderUpdate
             * @function getTypeUrl
             * @memberof api.trades.OrderUpdate
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            OrderUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/api.trades.OrderUpdate";
            };

            return OrderUpdate;
        })();

        trades.PositionUpdate = (function() {

            /**
             * Properties of a PositionUpdate.
             * @memberof api.trades
             * @interface IPositionUpdate
             * @property {string|null} [entityId] PositionUpdate entityId
             * @property {number|null} [averagePrice] PositionUpdate averagePrice
             * @property {number|Long|null} [lot] PositionUpdate lot
             * @property {number|Long|null} [quantity] PositionUpdate quantity
             * @property {number|Long|null} [elapsedTime] PositionUpdate elapsedTime
             * @property {number|null} [realisedGainLoss] PositionUpdate realisedGainLoss
             */

            /**
             * Constructs a new PositionUpdate.
             * @memberof api.trades
             * @classdesc Represents a PositionUpdate.
             * @implements IPositionUpdate
             * @constructor
             * @param {api.trades.IPositionUpdate=} [properties] Properties to set
             */
            function PositionUpdate(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PositionUpdate entityId.
             * @member {string} entityId
             * @memberof api.trades.PositionUpdate
             * @instance
             */
            PositionUpdate.prototype.entityId = "";

            /**
             * PositionUpdate averagePrice.
             * @member {number} averagePrice
             * @memberof api.trades.PositionUpdate
             * @instance
             */
            PositionUpdate.prototype.averagePrice = 0;

            /**
             * PositionUpdate lot.
             * @member {number|Long} lot
             * @memberof api.trades.PositionUpdate
             * @instance
             */
            PositionUpdate.prototype.lot = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * PositionUpdate quantity.
             * @member {number|Long} quantity
             * @memberof api.trades.PositionUpdate
             * @instance
             */
            PositionUpdate.prototype.quantity = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * PositionUpdate elapsedTime.
             * @member {number|Long} elapsedTime
             * @memberof api.trades.PositionUpdate
             * @instance
             */
            PositionUpdate.prototype.elapsedTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * PositionUpdate realisedGainLoss.
             * @member {number} realisedGainLoss
             * @memberof api.trades.PositionUpdate
             * @instance
             */
            PositionUpdate.prototype.realisedGainLoss = 0;

            /**
             * Creates a new PositionUpdate instance using the specified properties.
             * @function create
             * @memberof api.trades.PositionUpdate
             * @static
             * @param {api.trades.IPositionUpdate=} [properties] Properties to set
             * @returns {api.trades.PositionUpdate} PositionUpdate instance
             */
            PositionUpdate.create = function create(properties) {
                return new PositionUpdate(properties);
            };

            /**
             * Encodes the specified PositionUpdate message. Does not implicitly {@link api.trades.PositionUpdate.verify|verify} messages.
             * @function encode
             * @memberof api.trades.PositionUpdate
             * @static
             * @param {api.trades.IPositionUpdate} message PositionUpdate message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PositionUpdate.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.entityId != null && Object.hasOwnProperty.call(message, "entityId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.entityId);
                if (message.averagePrice != null && Object.hasOwnProperty.call(message, "averagePrice"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.averagePrice);
                if (message.lot != null && Object.hasOwnProperty.call(message, "lot"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.lot);
                if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.quantity);
                if (message.elapsedTime != null && Object.hasOwnProperty.call(message, "elapsedTime"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int64(message.elapsedTime);
                if (message.realisedGainLoss != null && Object.hasOwnProperty.call(message, "realisedGainLoss"))
                    writer.uint32(/* id 6, wireType 1 =*/49).double(message.realisedGainLoss);
                return writer;
            };

            /**
             * Encodes the specified PositionUpdate message, length delimited. Does not implicitly {@link api.trades.PositionUpdate.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.trades.PositionUpdate
             * @static
             * @param {api.trades.IPositionUpdate} message PositionUpdate message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PositionUpdate.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PositionUpdate message from the specified reader or buffer.
             * @function decode
             * @memberof api.trades.PositionUpdate
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.trades.PositionUpdate} PositionUpdate
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PositionUpdate.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.trades.PositionUpdate();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.entityId = reader.string();
                            break;
                        }
                    case 2: {
                            message.averagePrice = reader.double();
                            break;
                        }
                    case 3: {
                            message.lot = reader.int64();
                            break;
                        }
                    case 4: {
                            message.quantity = reader.int64();
                            break;
                        }
                    case 5: {
                            message.elapsedTime = reader.int64();
                            break;
                        }
                    case 6: {
                            message.realisedGainLoss = reader.double();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PositionUpdate message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.trades.PositionUpdate
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.trades.PositionUpdate} PositionUpdate
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PositionUpdate.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PositionUpdate message.
             * @function verify
             * @memberof api.trades.PositionUpdate
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PositionUpdate.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.entityId != null && message.hasOwnProperty("entityId"))
                    if (!$util.isString(message.entityId))
                        return "entityId: string expected";
                if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
                    if (typeof message.averagePrice !== "number")
                        return "averagePrice: number expected";
                if (message.lot != null && message.hasOwnProperty("lot"))
                    if (!$util.isInteger(message.lot) && !(message.lot && $util.isInteger(message.lot.low) && $util.isInteger(message.lot.high)))
                        return "lot: integer|Long expected";
                if (message.quantity != null && message.hasOwnProperty("quantity"))
                    if (!$util.isInteger(message.quantity) && !(message.quantity && $util.isInteger(message.quantity.low) && $util.isInteger(message.quantity.high)))
                        return "quantity: integer|Long expected";
                if (message.elapsedTime != null && message.hasOwnProperty("elapsedTime"))
                    if (!$util.isInteger(message.elapsedTime) && !(message.elapsedTime && $util.isInteger(message.elapsedTime.low) && $util.isInteger(message.elapsedTime.high)))
                        return "elapsedTime: integer|Long expected";
                if (message.realisedGainLoss != null && message.hasOwnProperty("realisedGainLoss"))
                    if (typeof message.realisedGainLoss !== "number")
                        return "realisedGainLoss: number expected";
                return null;
            };

            /**
             * Creates a PositionUpdate message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.trades.PositionUpdate
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.trades.PositionUpdate} PositionUpdate
             */
            PositionUpdate.fromObject = function fromObject(object) {
                if (object instanceof $root.api.trades.PositionUpdate)
                    return object;
                let message = new $root.api.trades.PositionUpdate();
                if (object.entityId != null)
                    message.entityId = String(object.entityId);
                if (object.averagePrice != null)
                    message.averagePrice = Number(object.averagePrice);
                if (object.lot != null)
                    if ($util.Long)
                        (message.lot = $util.Long.fromValue(object.lot)).unsigned = false;
                    else if (typeof object.lot === "string")
                        message.lot = parseInt(object.lot, 10);
                    else if (typeof object.lot === "number")
                        message.lot = object.lot;
                    else if (typeof object.lot === "object")
                        message.lot = new $util.LongBits(object.lot.low >>> 0, object.lot.high >>> 0).toNumber();
                if (object.quantity != null)
                    if ($util.Long)
                        (message.quantity = $util.Long.fromValue(object.quantity)).unsigned = false;
                    else if (typeof object.quantity === "string")
                        message.quantity = parseInt(object.quantity, 10);
                    else if (typeof object.quantity === "number")
                        message.quantity = object.quantity;
                    else if (typeof object.quantity === "object")
                        message.quantity = new $util.LongBits(object.quantity.low >>> 0, object.quantity.high >>> 0).toNumber();
                if (object.elapsedTime != null)
                    if ($util.Long)
                        (message.elapsedTime = $util.Long.fromValue(object.elapsedTime)).unsigned = false;
                    else if (typeof object.elapsedTime === "string")
                        message.elapsedTime = parseInt(object.elapsedTime, 10);
                    else if (typeof object.elapsedTime === "number")
                        message.elapsedTime = object.elapsedTime;
                    else if (typeof object.elapsedTime === "object")
                        message.elapsedTime = new $util.LongBits(object.elapsedTime.low >>> 0, object.elapsedTime.high >>> 0).toNumber();
                if (object.realisedGainLoss != null)
                    message.realisedGainLoss = Number(object.realisedGainLoss);
                return message;
            };

            /**
             * Creates a plain object from a PositionUpdate message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.trades.PositionUpdate
             * @static
             * @param {api.trades.PositionUpdate} message PositionUpdate
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PositionUpdate.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.entityId = "";
                    object.averagePrice = 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.lot = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.lot = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.quantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.quantity = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.elapsedTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.elapsedTime = options.longs === String ? "0" : 0;
                    object.realisedGainLoss = 0;
                }
                if (message.entityId != null && message.hasOwnProperty("entityId"))
                    object.entityId = message.entityId;
                if (message.averagePrice != null && message.hasOwnProperty("averagePrice"))
                    object.averagePrice = options.json && !isFinite(message.averagePrice) ? String(message.averagePrice) : message.averagePrice;
                if (message.lot != null && message.hasOwnProperty("lot"))
                    if (typeof message.lot === "number")
                        object.lot = options.longs === String ? String(message.lot) : message.lot;
                    else
                        object.lot = options.longs === String ? $util.Long.prototype.toString.call(message.lot) : options.longs === Number ? new $util.LongBits(message.lot.low >>> 0, message.lot.high >>> 0).toNumber() : message.lot;
                if (message.quantity != null && message.hasOwnProperty("quantity"))
                    if (typeof message.quantity === "number")
                        object.quantity = options.longs === String ? String(message.quantity) : message.quantity;
                    else
                        object.quantity = options.longs === String ? $util.Long.prototype.toString.call(message.quantity) : options.longs === Number ? new $util.LongBits(message.quantity.low >>> 0, message.quantity.high >>> 0).toNumber() : message.quantity;
                if (message.elapsedTime != null && message.hasOwnProperty("elapsedTime"))
                    if (typeof message.elapsedTime === "number")
                        object.elapsedTime = options.longs === String ? String(message.elapsedTime) : message.elapsedTime;
                    else
                        object.elapsedTime = options.longs === String ? $util.Long.prototype.toString.call(message.elapsedTime) : options.longs === Number ? new $util.LongBits(message.elapsedTime.low >>> 0, message.elapsedTime.high >>> 0).toNumber() : message.elapsedTime;
                if (message.realisedGainLoss != null && message.hasOwnProperty("realisedGainLoss"))
                    object.realisedGainLoss = options.json && !isFinite(message.realisedGainLoss) ? String(message.realisedGainLoss) : message.realisedGainLoss;
                return object;
            };

            /**
             * Converts this PositionUpdate to JSON.
             * @function toJSON
             * @memberof api.trades.PositionUpdate
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PositionUpdate.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PositionUpdate
             * @function getTypeUrl
             * @memberof api.trades.PositionUpdate
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PositionUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/api.trades.PositionUpdate";
            };

            return PositionUpdate;
        })();

        trades.GttUpdate = (function() {

            /**
             * Properties of a GttUpdate.
             * @memberof api.trades
             * @interface IGttUpdate
             * @property {string|null} [orderId] GttUpdate orderId
             * @property {number|null} [stopLossPrice] GttUpdate stopLossPrice
             * @property {number|null} [stopLossLimitPrice] GttUpdate stopLossLimitPrice
             * @property {number|null} [targetPrice] GttUpdate targetPrice
             * @property {number|null} [targetLimitPrice] GttUpdate targetLimitPrice
             * @property {string|null} [orderType] GttUpdate orderType
             * @property {string|null} [status] GttUpdate status
             * @property {string|null} [orderOrigin] GttUpdate orderOrigin
             * @property {string|null} [vyaparOrderId] GttUpdate vyaparOrderId
             * @property {string|null} [txnType] GttUpdate txnType
             * @property {string|null} [exchange] GttUpdate exchange
             * @property {string|null} [validity] GttUpdate validity
             * @property {number|Long|null} [requiredQuantity] GttUpdate requiredQuantity
             * @property {number|Long|null} [fulfilledQuantity] GttUpdate fulfilledQuantity
             */

            /**
             * Constructs a new GttUpdate.
             * @memberof api.trades
             * @classdesc Represents a GttUpdate.
             * @implements IGttUpdate
             * @constructor
             * @param {api.trades.IGttUpdate=} [properties] Properties to set
             */
            function GttUpdate(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GttUpdate orderId.
             * @member {string} orderId
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.orderId = "";

            /**
             * GttUpdate stopLossPrice.
             * @member {number} stopLossPrice
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.stopLossPrice = 0;

            /**
             * GttUpdate stopLossLimitPrice.
             * @member {number} stopLossLimitPrice
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.stopLossLimitPrice = 0;

            /**
             * GttUpdate targetPrice.
             * @member {number} targetPrice
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.targetPrice = 0;

            /**
             * GttUpdate targetLimitPrice.
             * @member {number} targetLimitPrice
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.targetLimitPrice = 0;

            /**
             * GttUpdate orderType.
             * @member {string} orderType
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.orderType = "";

            /**
             * GttUpdate status.
             * @member {string} status
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.status = "";

            /**
             * GttUpdate orderOrigin.
             * @member {string} orderOrigin
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.orderOrigin = "";

            /**
             * GttUpdate vyaparOrderId.
             * @member {string} vyaparOrderId
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.vyaparOrderId = "";

            /**
             * GttUpdate txnType.
             * @member {string} txnType
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.txnType = "";

            /**
             * GttUpdate exchange.
             * @member {string} exchange
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.exchange = "";

            /**
             * GttUpdate validity.
             * @member {string} validity
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.validity = "";

            /**
             * GttUpdate requiredQuantity.
             * @member {number|Long} requiredQuantity
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.requiredQuantity = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * GttUpdate fulfilledQuantity.
             * @member {number|Long} fulfilledQuantity
             * @memberof api.trades.GttUpdate
             * @instance
             */
            GttUpdate.prototype.fulfilledQuantity = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new GttUpdate instance using the specified properties.
             * @function create
             * @memberof api.trades.GttUpdate
             * @static
             * @param {api.trades.IGttUpdate=} [properties] Properties to set
             * @returns {api.trades.GttUpdate} GttUpdate instance
             */
            GttUpdate.create = function create(properties) {
                return new GttUpdate(properties);
            };

            /**
             * Encodes the specified GttUpdate message. Does not implicitly {@link api.trades.GttUpdate.verify|verify} messages.
             * @function encode
             * @memberof api.trades.GttUpdate
             * @static
             * @param {api.trades.IGttUpdate} message GttUpdate message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GttUpdate.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.orderId != null && Object.hasOwnProperty.call(message, "orderId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.orderId);
                if (message.stopLossPrice != null && Object.hasOwnProperty.call(message, "stopLossPrice"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.stopLossPrice);
                if (message.stopLossLimitPrice != null && Object.hasOwnProperty.call(message, "stopLossLimitPrice"))
                    writer.uint32(/* id 3, wireType 1 =*/25).double(message.stopLossLimitPrice);
                if (message.targetPrice != null && Object.hasOwnProperty.call(message, "targetPrice"))
                    writer.uint32(/* id 4, wireType 1 =*/33).double(message.targetPrice);
                if (message.targetLimitPrice != null && Object.hasOwnProperty.call(message, "targetLimitPrice"))
                    writer.uint32(/* id 5, wireType 1 =*/41).double(message.targetLimitPrice);
                if (message.orderType != null && Object.hasOwnProperty.call(message, "orderType"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.orderType);
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.status);
                if (message.orderOrigin != null && Object.hasOwnProperty.call(message, "orderOrigin"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.orderOrigin);
                if (message.vyaparOrderId != null && Object.hasOwnProperty.call(message, "vyaparOrderId"))
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.vyaparOrderId);
                if (message.txnType != null && Object.hasOwnProperty.call(message, "txnType"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.txnType);
                if (message.exchange != null && Object.hasOwnProperty.call(message, "exchange"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.exchange);
                if (message.validity != null && Object.hasOwnProperty.call(message, "validity"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.validity);
                if (message.requiredQuantity != null && Object.hasOwnProperty.call(message, "requiredQuantity"))
                    writer.uint32(/* id 13, wireType 0 =*/104).int64(message.requiredQuantity);
                if (message.fulfilledQuantity != null && Object.hasOwnProperty.call(message, "fulfilledQuantity"))
                    writer.uint32(/* id 14, wireType 0 =*/112).int64(message.fulfilledQuantity);
                return writer;
            };

            /**
             * Encodes the specified GttUpdate message, length delimited. Does not implicitly {@link api.trades.GttUpdate.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.trades.GttUpdate
             * @static
             * @param {api.trades.IGttUpdate} message GttUpdate message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GttUpdate.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GttUpdate message from the specified reader or buffer.
             * @function decode
             * @memberof api.trades.GttUpdate
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.trades.GttUpdate} GttUpdate
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GttUpdate.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.trades.GttUpdate();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.orderId = reader.string();
                            break;
                        }
                    case 2: {
                            message.stopLossPrice = reader.double();
                            break;
                        }
                    case 3: {
                            message.stopLossLimitPrice = reader.double();
                            break;
                        }
                    case 4: {
                            message.targetPrice = reader.double();
                            break;
                        }
                    case 5: {
                            message.targetLimitPrice = reader.double();
                            break;
                        }
                    case 6: {
                            message.orderType = reader.string();
                            break;
                        }
                    case 7: {
                            message.status = reader.string();
                            break;
                        }
                    case 8: {
                            message.orderOrigin = reader.string();
                            break;
                        }
                    case 9: {
                            message.vyaparOrderId = reader.string();
                            break;
                        }
                    case 10: {
                            message.txnType = reader.string();
                            break;
                        }
                    case 11: {
                            message.exchange = reader.string();
                            break;
                        }
                    case 12: {
                            message.validity = reader.string();
                            break;
                        }
                    case 13: {
                            message.requiredQuantity = reader.int64();
                            break;
                        }
                    case 14: {
                            message.fulfilledQuantity = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GttUpdate message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.trades.GttUpdate
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.trades.GttUpdate} GttUpdate
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GttUpdate.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GttUpdate message.
             * @function verify
             * @memberof api.trades.GttUpdate
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GttUpdate.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.orderId != null && message.hasOwnProperty("orderId"))
                    if (!$util.isString(message.orderId))
                        return "orderId: string expected";
                if (message.stopLossPrice != null && message.hasOwnProperty("stopLossPrice"))
                    if (typeof message.stopLossPrice !== "number")
                        return "stopLossPrice: number expected";
                if (message.stopLossLimitPrice != null && message.hasOwnProperty("stopLossLimitPrice"))
                    if (typeof message.stopLossLimitPrice !== "number")
                        return "stopLossLimitPrice: number expected";
                if (message.targetPrice != null && message.hasOwnProperty("targetPrice"))
                    if (typeof message.targetPrice !== "number")
                        return "targetPrice: number expected";
                if (message.targetLimitPrice != null && message.hasOwnProperty("targetLimitPrice"))
                    if (typeof message.targetLimitPrice !== "number")
                        return "targetLimitPrice: number expected";
                if (message.orderType != null && message.hasOwnProperty("orderType"))
                    if (!$util.isString(message.orderType))
                        return "orderType: string expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    if (!$util.isString(message.status))
                        return "status: string expected";
                if (message.orderOrigin != null && message.hasOwnProperty("orderOrigin"))
                    if (!$util.isString(message.orderOrigin))
                        return "orderOrigin: string expected";
                if (message.vyaparOrderId != null && message.hasOwnProperty("vyaparOrderId"))
                    if (!$util.isString(message.vyaparOrderId))
                        return "vyaparOrderId: string expected";
                if (message.txnType != null && message.hasOwnProperty("txnType"))
                    if (!$util.isString(message.txnType))
                        return "txnType: string expected";
                if (message.exchange != null && message.hasOwnProperty("exchange"))
                    if (!$util.isString(message.exchange))
                        return "exchange: string expected";
                if (message.validity != null && message.hasOwnProperty("validity"))
                    if (!$util.isString(message.validity))
                        return "validity: string expected";
                if (message.requiredQuantity != null && message.hasOwnProperty("requiredQuantity"))
                    if (!$util.isInteger(message.requiredQuantity) && !(message.requiredQuantity && $util.isInteger(message.requiredQuantity.low) && $util.isInteger(message.requiredQuantity.high)))
                        return "requiredQuantity: integer|Long expected";
                if (message.fulfilledQuantity != null && message.hasOwnProperty("fulfilledQuantity"))
                    if (!$util.isInteger(message.fulfilledQuantity) && !(message.fulfilledQuantity && $util.isInteger(message.fulfilledQuantity.low) && $util.isInteger(message.fulfilledQuantity.high)))
                        return "fulfilledQuantity: integer|Long expected";
                return null;
            };

            /**
             * Creates a GttUpdate message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.trades.GttUpdate
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.trades.GttUpdate} GttUpdate
             */
            GttUpdate.fromObject = function fromObject(object) {
                if (object instanceof $root.api.trades.GttUpdate)
                    return object;
                let message = new $root.api.trades.GttUpdate();
                if (object.orderId != null)
                    message.orderId = String(object.orderId);
                if (object.stopLossPrice != null)
                    message.stopLossPrice = Number(object.stopLossPrice);
                if (object.stopLossLimitPrice != null)
                    message.stopLossLimitPrice = Number(object.stopLossLimitPrice);
                if (object.targetPrice != null)
                    message.targetPrice = Number(object.targetPrice);
                if (object.targetLimitPrice != null)
                    message.targetLimitPrice = Number(object.targetLimitPrice);
                if (object.orderType != null)
                    message.orderType = String(object.orderType);
                if (object.status != null)
                    message.status = String(object.status);
                if (object.orderOrigin != null)
                    message.orderOrigin = String(object.orderOrigin);
                if (object.vyaparOrderId != null)
                    message.vyaparOrderId = String(object.vyaparOrderId);
                if (object.txnType != null)
                    message.txnType = String(object.txnType);
                if (object.exchange != null)
                    message.exchange = String(object.exchange);
                if (object.validity != null)
                    message.validity = String(object.validity);
                if (object.requiredQuantity != null)
                    if ($util.Long)
                        (message.requiredQuantity = $util.Long.fromValue(object.requiredQuantity)).unsigned = false;
                    else if (typeof object.requiredQuantity === "string")
                        message.requiredQuantity = parseInt(object.requiredQuantity, 10);
                    else if (typeof object.requiredQuantity === "number")
                        message.requiredQuantity = object.requiredQuantity;
                    else if (typeof object.requiredQuantity === "object")
                        message.requiredQuantity = new $util.LongBits(object.requiredQuantity.low >>> 0, object.requiredQuantity.high >>> 0).toNumber();
                if (object.fulfilledQuantity != null)
                    if ($util.Long)
                        (message.fulfilledQuantity = $util.Long.fromValue(object.fulfilledQuantity)).unsigned = false;
                    else if (typeof object.fulfilledQuantity === "string")
                        message.fulfilledQuantity = parseInt(object.fulfilledQuantity, 10);
                    else if (typeof object.fulfilledQuantity === "number")
                        message.fulfilledQuantity = object.fulfilledQuantity;
                    else if (typeof object.fulfilledQuantity === "object")
                        message.fulfilledQuantity = new $util.LongBits(object.fulfilledQuantity.low >>> 0, object.fulfilledQuantity.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a GttUpdate message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.trades.GttUpdate
             * @static
             * @param {api.trades.GttUpdate} message GttUpdate
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GttUpdate.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.orderId = "";
                    object.stopLossPrice = 0;
                    object.stopLossLimitPrice = 0;
                    object.targetPrice = 0;
                    object.targetLimitPrice = 0;
                    object.orderType = "";
                    object.status = "";
                    object.orderOrigin = "";
                    object.vyaparOrderId = "";
                    object.txnType = "";
                    object.exchange = "";
                    object.validity = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.requiredQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.requiredQuantity = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.fulfilledQuantity = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.fulfilledQuantity = options.longs === String ? "0" : 0;
                }
                if (message.orderId != null && message.hasOwnProperty("orderId"))
                    object.orderId = message.orderId;
                if (message.stopLossPrice != null && message.hasOwnProperty("stopLossPrice"))
                    object.stopLossPrice = options.json && !isFinite(message.stopLossPrice) ? String(message.stopLossPrice) : message.stopLossPrice;
                if (message.stopLossLimitPrice != null && message.hasOwnProperty("stopLossLimitPrice"))
                    object.stopLossLimitPrice = options.json && !isFinite(message.stopLossLimitPrice) ? String(message.stopLossLimitPrice) : message.stopLossLimitPrice;
                if (message.targetPrice != null && message.hasOwnProperty("targetPrice"))
                    object.targetPrice = options.json && !isFinite(message.targetPrice) ? String(message.targetPrice) : message.targetPrice;
                if (message.targetLimitPrice != null && message.hasOwnProperty("targetLimitPrice"))
                    object.targetLimitPrice = options.json && !isFinite(message.targetLimitPrice) ? String(message.targetLimitPrice) : message.targetLimitPrice;
                if (message.orderType != null && message.hasOwnProperty("orderType"))
                    object.orderType = message.orderType;
                if (message.status != null && message.hasOwnProperty("status"))
                    object.status = message.status;
                if (message.orderOrigin != null && message.hasOwnProperty("orderOrigin"))
                    object.orderOrigin = message.orderOrigin;
                if (message.vyaparOrderId != null && message.hasOwnProperty("vyaparOrderId"))
                    object.vyaparOrderId = message.vyaparOrderId;
                if (message.txnType != null && message.hasOwnProperty("txnType"))
                    object.txnType = message.txnType;
                if (message.exchange != null && message.hasOwnProperty("exchange"))
                    object.exchange = message.exchange;
                if (message.validity != null && message.hasOwnProperty("validity"))
                    object.validity = message.validity;
                if (message.requiredQuantity != null && message.hasOwnProperty("requiredQuantity"))
                    if (typeof message.requiredQuantity === "number")
                        object.requiredQuantity = options.longs === String ? String(message.requiredQuantity) : message.requiredQuantity;
                    else
                        object.requiredQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.requiredQuantity) : options.longs === Number ? new $util.LongBits(message.requiredQuantity.low >>> 0, message.requiredQuantity.high >>> 0).toNumber() : message.requiredQuantity;
                if (message.fulfilledQuantity != null && message.hasOwnProperty("fulfilledQuantity"))
                    if (typeof message.fulfilledQuantity === "number")
                        object.fulfilledQuantity = options.longs === String ? String(message.fulfilledQuantity) : message.fulfilledQuantity;
                    else
                        object.fulfilledQuantity = options.longs === String ? $util.Long.prototype.toString.call(message.fulfilledQuantity) : options.longs === Number ? new $util.LongBits(message.fulfilledQuantity.low >>> 0, message.fulfilledQuantity.high >>> 0).toNumber() : message.fulfilledQuantity;
                return object;
            };

            /**
             * Converts this GttUpdate to JSON.
             * @function toJSON
             * @memberof api.trades.GttUpdate
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GttUpdate.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for GttUpdate
             * @function getTypeUrl
             * @memberof api.trades.GttUpdate
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            GttUpdate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/api.trades.GttUpdate";
            };

            return GttUpdate;
        })();

        trades.TradeData = (function() {

            /**
             * Properties of a TradeData.
             * @memberof api.trades
             * @interface ITradeData
             * @property {string|null} [mode] TradeData mode
             * @property {Array.<api.trades.IOrderUpdate>|null} [orderUpdate] TradeData orderUpdate
             * @property {Array.<api.trades.IPositionUpdate>|null} [positionUpdate] TradeData positionUpdate
             * @property {number|Long|null} [sentTs] TradeData sentTs
             * @property {string|null} [subPath] TradeData subPath
             * @property {Array.<api.trades.IGttUpdate>|null} [gttUpdate] TradeData gttUpdate
             */

            /**
             * Constructs a new TradeData.
             * @memberof api.trades
             * @classdesc Represents a TradeData.
             * @implements ITradeData
             * @constructor
             * @param {api.trades.ITradeData=} [properties] Properties to set
             */
            function TradeData(properties) {
                this.orderUpdate = [];
                this.positionUpdate = [];
                this.gttUpdate = [];
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * TradeData mode.
             * @member {string} mode
             * @memberof api.trades.TradeData
             * @instance
             */
            TradeData.prototype.mode = "";

            /**
             * TradeData orderUpdate.
             * @member {Array.<api.trades.IOrderUpdate>} orderUpdate
             * @memberof api.trades.TradeData
             * @instance
             */
            TradeData.prototype.orderUpdate = $util.emptyArray;

            /**
             * TradeData positionUpdate.
             * @member {Array.<api.trades.IPositionUpdate>} positionUpdate
             * @memberof api.trades.TradeData
             * @instance
             */
            TradeData.prototype.positionUpdate = $util.emptyArray;

            /**
             * TradeData sentTs.
             * @member {number|Long} sentTs
             * @memberof api.trades.TradeData
             * @instance
             */
            TradeData.prototype.sentTs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * TradeData subPath.
             * @member {string} subPath
             * @memberof api.trades.TradeData
             * @instance
             */
            TradeData.prototype.subPath = "";

            /**
             * TradeData gttUpdate.
             * @member {Array.<api.trades.IGttUpdate>} gttUpdate
             * @memberof api.trades.TradeData
             * @instance
             */
            TradeData.prototype.gttUpdate = $util.emptyArray;

            /**
             * Creates a new TradeData instance using the specified properties.
             * @function create
             * @memberof api.trades.TradeData
             * @static
             * @param {api.trades.ITradeData=} [properties] Properties to set
             * @returns {api.trades.TradeData} TradeData instance
             */
            TradeData.create = function create(properties) {
                return new TradeData(properties);
            };

            /**
             * Encodes the specified TradeData message. Does not implicitly {@link api.trades.TradeData.verify|verify} messages.
             * @function encode
             * @memberof api.trades.TradeData
             * @static
             * @param {api.trades.ITradeData} message TradeData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TradeData.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.mode);
                if (message.orderUpdate != null && message.orderUpdate.length)
                    for (let i = 0; i < message.orderUpdate.length; ++i)
                        $root.api.trades.OrderUpdate.encode(message.orderUpdate[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.positionUpdate != null && message.positionUpdate.length)
                    for (let i = 0; i < message.positionUpdate.length; ++i)
                        $root.api.trades.PositionUpdate.encode(message.positionUpdate[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.sentTs != null && Object.hasOwnProperty.call(message, "sentTs"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.sentTs);
                if (message.subPath != null && Object.hasOwnProperty.call(message, "subPath"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.subPath);
                if (message.gttUpdate != null && message.gttUpdate.length)
                    for (let i = 0; i < message.gttUpdate.length; ++i)
                        $root.api.trades.GttUpdate.encode(message.gttUpdate[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified TradeData message, length delimited. Does not implicitly {@link api.trades.TradeData.verify|verify} messages.
             * @function encodeDelimited
             * @memberof api.trades.TradeData
             * @static
             * @param {api.trades.ITradeData} message TradeData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            TradeData.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a TradeData message from the specified reader or buffer.
             * @function decode
             * @memberof api.trades.TradeData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {api.trades.TradeData} TradeData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TradeData.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.api.trades.TradeData();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.mode = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.orderUpdate && message.orderUpdate.length))
                                message.orderUpdate = [];
                            message.orderUpdate.push($root.api.trades.OrderUpdate.decode(reader, reader.uint32()));
                            break;
                        }
                    case 3: {
                            if (!(message.positionUpdate && message.positionUpdate.length))
                                message.positionUpdate = [];
                            message.positionUpdate.push($root.api.trades.PositionUpdate.decode(reader, reader.uint32()));
                            break;
                        }
                    case 4: {
                            message.sentTs = reader.int64();
                            break;
                        }
                    case 5: {
                            message.subPath = reader.string();
                            break;
                        }
                    case 6: {
                            if (!(message.gttUpdate && message.gttUpdate.length))
                                message.gttUpdate = [];
                            message.gttUpdate.push($root.api.trades.GttUpdate.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a TradeData message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof api.trades.TradeData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {api.trades.TradeData} TradeData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            TradeData.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a TradeData message.
             * @function verify
             * @memberof api.trades.TradeData
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            TradeData.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.mode != null && message.hasOwnProperty("mode"))
                    if (!$util.isString(message.mode))
                        return "mode: string expected";
                if (message.orderUpdate != null && message.hasOwnProperty("orderUpdate")) {
                    if (!Array.isArray(message.orderUpdate))
                        return "orderUpdate: array expected";
                    for (let i = 0; i < message.orderUpdate.length; ++i) {
                        let error = $root.api.trades.OrderUpdate.verify(message.orderUpdate[i]);
                        if (error)
                            return "orderUpdate." + error;
                    }
                }
                if (message.positionUpdate != null && message.hasOwnProperty("positionUpdate")) {
                    if (!Array.isArray(message.positionUpdate))
                        return "positionUpdate: array expected";
                    for (let i = 0; i < message.positionUpdate.length; ++i) {
                        let error = $root.api.trades.PositionUpdate.verify(message.positionUpdate[i]);
                        if (error)
                            return "positionUpdate." + error;
                    }
                }
                if (message.sentTs != null && message.hasOwnProperty("sentTs"))
                    if (!$util.isInteger(message.sentTs) && !(message.sentTs && $util.isInteger(message.sentTs.low) && $util.isInteger(message.sentTs.high)))
                        return "sentTs: integer|Long expected";
                if (message.subPath != null && message.hasOwnProperty("subPath"))
                    if (!$util.isString(message.subPath))
                        return "subPath: string expected";
                if (message.gttUpdate != null && message.hasOwnProperty("gttUpdate")) {
                    if (!Array.isArray(message.gttUpdate))
                        return "gttUpdate: array expected";
                    for (let i = 0; i < message.gttUpdate.length; ++i) {
                        let error = $root.api.trades.GttUpdate.verify(message.gttUpdate[i]);
                        if (error)
                            return "gttUpdate." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a TradeData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof api.trades.TradeData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {api.trades.TradeData} TradeData
             */
            TradeData.fromObject = function fromObject(object) {
                if (object instanceof $root.api.trades.TradeData)
                    return object;
                let message = new $root.api.trades.TradeData();
                if (object.mode != null)
                    message.mode = String(object.mode);
                if (object.orderUpdate) {
                    if (!Array.isArray(object.orderUpdate))
                        throw TypeError(".api.trades.TradeData.orderUpdate: array expected");
                    message.orderUpdate = [];
                    for (let i = 0; i < object.orderUpdate.length; ++i) {
                        if (typeof object.orderUpdate[i] !== "object")
                            throw TypeError(".api.trades.TradeData.orderUpdate: object expected");
                        message.orderUpdate[i] = $root.api.trades.OrderUpdate.fromObject(object.orderUpdate[i]);
                    }
                }
                if (object.positionUpdate) {
                    if (!Array.isArray(object.positionUpdate))
                        throw TypeError(".api.trades.TradeData.positionUpdate: array expected");
                    message.positionUpdate = [];
                    for (let i = 0; i < object.positionUpdate.length; ++i) {
                        if (typeof object.positionUpdate[i] !== "object")
                            throw TypeError(".api.trades.TradeData.positionUpdate: object expected");
                        message.positionUpdate[i] = $root.api.trades.PositionUpdate.fromObject(object.positionUpdate[i]);
                    }
                }
                if (object.sentTs != null)
                    if ($util.Long)
                        (message.sentTs = $util.Long.fromValue(object.sentTs)).unsigned = false;
                    else if (typeof object.sentTs === "string")
                        message.sentTs = parseInt(object.sentTs, 10);
                    else if (typeof object.sentTs === "number")
                        message.sentTs = object.sentTs;
                    else if (typeof object.sentTs === "object")
                        message.sentTs = new $util.LongBits(object.sentTs.low >>> 0, object.sentTs.high >>> 0).toNumber();
                if (object.subPath != null)
                    message.subPath = String(object.subPath);
                if (object.gttUpdate) {
                    if (!Array.isArray(object.gttUpdate))
                        throw TypeError(".api.trades.TradeData.gttUpdate: array expected");
                    message.gttUpdate = [];
                    for (let i = 0; i < object.gttUpdate.length; ++i) {
                        if (typeof object.gttUpdate[i] !== "object")
                            throw TypeError(".api.trades.TradeData.gttUpdate: object expected");
                        message.gttUpdate[i] = $root.api.trades.GttUpdate.fromObject(object.gttUpdate[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a TradeData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof api.trades.TradeData
             * @static
             * @param {api.trades.TradeData} message TradeData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            TradeData.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.arrays || options.defaults) {
                    object.orderUpdate = [];
                    object.positionUpdate = [];
                    object.gttUpdate = [];
                }
                if (options.defaults) {
                    object.mode = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.sentTs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.sentTs = options.longs === String ? "0" : 0;
                    object.subPath = "";
                }
                if (message.mode != null && message.hasOwnProperty("mode"))
                    object.mode = message.mode;
                if (message.orderUpdate && message.orderUpdate.length) {
                    object.orderUpdate = [];
                    for (let j = 0; j < message.orderUpdate.length; ++j)
                        object.orderUpdate[j] = $root.api.trades.OrderUpdate.toObject(message.orderUpdate[j], options);
                }
                if (message.positionUpdate && message.positionUpdate.length) {
                    object.positionUpdate = [];
                    for (let j = 0; j < message.positionUpdate.length; ++j)
                        object.positionUpdate[j] = $root.api.trades.PositionUpdate.toObject(message.positionUpdate[j], options);
                }
                if (message.sentTs != null && message.hasOwnProperty("sentTs"))
                    if (typeof message.sentTs === "number")
                        object.sentTs = options.longs === String ? String(message.sentTs) : message.sentTs;
                    else
                        object.sentTs = options.longs === String ? $util.Long.prototype.toString.call(message.sentTs) : options.longs === Number ? new $util.LongBits(message.sentTs.low >>> 0, message.sentTs.high >>> 0).toNumber() : message.sentTs;
                if (message.subPath != null && message.hasOwnProperty("subPath"))
                    object.subPath = message.subPath;
                if (message.gttUpdate && message.gttUpdate.length) {
                    object.gttUpdate = [];
                    for (let j = 0; j < message.gttUpdate.length; ++j)
                        object.gttUpdate[j] = $root.api.trades.GttUpdate.toObject(message.gttUpdate[j], options);
                }
                return object;
            };

            /**
             * Converts this TradeData to JSON.
             * @function toJSON
             * @memberof api.trades.TradeData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            TradeData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for TradeData
             * @function getTypeUrl
             * @memberof api.trades.TradeData
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            TradeData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/api.trades.TradeData";
            };

            return TradeData;
        })();

        return trades;
    })();

    return api;
})();

export { $root as default };
